// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"309":"a89bb3f9","593":"3cbc7e69"}[chunkId] + ".chunk.css";
};